(() => {
  const ASSOCIATED_URLS_SELECTOR = '[data-variant-associated-urls]';
  const GALLERY_SELECTOR = 'media-gallery';

  function parseSelectedVariantId() {
    const hiddenInput = document.querySelector('form[id^="product-form"] input[name="id"]');
    if (!hiddenInput) return null;
    return hiddenInput.value ? String(hiddenInput.value) : null;
  }

  function parseVariantMap(mapEl) {
    try {
      return JSON.parse(mapEl.textContent || '{}');
    } catch (e) {
      console.error('Failed to parse variant map:', e);
      return {};
    }
  }

function getPackMultiplier() {
  const selectedVariantEl = document.querySelector('[data-selected-variant]');
  if (!selectedVariantEl) return 1;
  
  try {
    const variant = JSON.parse(selectedVariantEl.textContent);
    const packSize = (variant.option2 || variant.option1 || '').toLowerCase();
    if (packSize.includes('12')) return 12;
    if (packSize.includes('starter')) return 12;
    if (packSize.includes('4')) return 4;
    return 1;
  } catch(e) {
    return 1;
  }
}

  function updateCountDisplay(variantData) {
    const countDisplay = document.getElementById('component-count-display');
    if (!countDisplay) return;
    const decalCount = variantData?.decal_count;
    if (!decalCount) return;
    const multiplier = getPackMultiplier();
    const total = decalCount * multiplier;
    countDisplay.textContent = `Includes ${total} decals per envelope (design specific)`;
  }

  function setActiveSlide(galleryEl, mediaId) {
    // Update main viewer
    galleryEl.querySelectorAll('[data-media-id]').forEach(el => el.classList.remove('is-active'));
    const activeSlide = galleryEl.querySelector(`[data-media-id="${mediaId}"]`);
    if (activeSlide) {
      activeSlide.classList.add('is-active');
      activeSlide.parentElement.scrollTo({ left: activeSlide.offsetLeft });
    }

    // Update thumbnail aria-current
    galleryEl.querySelectorAll('[data-target] button').forEach(btn => btn.removeAttribute('aria-current'));
    const activeThumb = galleryEl.querySelector(`[data-target="${mediaId}"]`);
    if (activeThumb) {
      const btn = activeThumb.querySelector('button');
      if (btn) btn.setAttribute('aria-current', 'true');
    }
  }

  function filterGallery(galleryEl, variantId) {
    // Show/hide slides
    galleryEl.querySelectorAll('[data-media-id]').forEach(slide => {
      const slideVariantId = slide.dataset.variantId;
      if (!slideVariantId) return;
      slide.style.display = slideVariantId === variantId ? '' : 'none';
    });

    // Show/hide thumbnails
    galleryEl.querySelectorAll('[data-target]').forEach(thumb => {
      const thumbVariantId = thumb.dataset.variantId;
      if (!thumbVariantId) return;
      thumb.style.display = thumbVariantId === variantId ? '' : 'none';
    });

    // Set first visible slide as active
    const firstSlide = galleryEl.querySelector(`[data-variant-id="${variantId}"][data-media-id]`);
    if (firstSlide) {
      setActiveSlide(galleryEl, firstSlide.dataset.mediaId);
    }
  }

  function bindThumbnailClicks(galleryEl) {
    galleryEl.querySelectorAll('[data-target]').forEach(thumb => {
      const button = thumb.querySelector('button');
      if (button && !button.dataset.bound) {
        button.dataset.bound = 'true';
        button.addEventListener('click', () => {
          const mediaId = thumb.dataset.target;
          setActiveSlide(galleryEl, mediaId);
        });
      }
    });
  }

  function applyAll(variantId) {
    document.querySelectorAll(GALLERY_SELECTOR).forEach(galleryEl => {
      filterGallery(galleryEl, variantId);
    });
  }

  function watchVariantInput(variantMap) {
    const hiddenInput = document.querySelector('form[id^="product-form"] input[name="id"]');
    if (!hiddenInput) {
      console.warn('No hidden variant input found');
      return;
    }

    hiddenInput.addEventListener('change', (e) => {
      const variantId = String(e.target.value);
      const variantData = variantMap[variantId];
      applyAll(variantId);
      updateCountDisplay(variantData);
      if (typeof window.dcUpdateConfigForVariant === 'function') {
        window.dcUpdateConfigForVariant(variantId);
      }
    });
  }

  function init() {
    const mapEl = document.querySelector(ASSOCIATED_URLS_SELECTOR);
    if (!mapEl) return;

    const variantMap = parseVariantMap(mapEl);
    if (!variantMap || Object.keys(variantMap).length === 0) {
      console.warn('Variant map is empty');
      return;
    }

    const variantId = parseSelectedVariantId();
    if (!variantId) {
      console.warn('No variant ID found on init');
      return;
    }

    const variantData = variantMap[variantId];

    // Bind thumbnail clicks for all galleries
    document.querySelectorAll(GALLERY_SELECTOR).forEach(galleryEl => {
      bindThumbnailClicks(galleryEl);
    });

    applyAll(variantId);
    updateCountDisplay(variantData);
    watchVariantInput(variantMap);
  }

  document.addEventListener('DOMContentLoaded', () => {
    init();
  });
})();